<template>
    <v-card :loading="loading">
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="mr-2">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3>EMAIL FOR CLOSURE NOTIFICATIONS</h3>
        </v-card-title>
        <v-divider class="ml-4 mr-5" />
        <v-card-text>
            <v-row no-gutters>
                <v-col cols="12">
                    <v-autocomplete
                        v-model="item.email"
                        :items="contactEmailOptions"
                        :loading="loadingContacts"
                        hide-details
                        prepend-icon="mdi-at"
                        label="email"
                        @paste="onPasteEmails"
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                color="primary"
                class="mb-4"
                @click="saveProcess"
                rounded
                :loading="loading"
            >
                SAVE
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import { objDiff } from '@/helpers/objDiff.js'

export default {
    name: 'ProjectClosureNotificationForm',
    props: {
        item: {
            type: Object,
            default: () => ({ email: '' }),
        },
        originalItem: {
            type: Object,
            default: () => ({}),
        },
        createForm: {
            type: Boolean,
            default: () => false,
        },
        projectsSettings: {
            type: Object,
            default: () => ({}),
        },
        emails: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        loading: false,
        usersEmailsList: [],
        loadingContacts: false,
        emailDelimiters: [',', ';', ' '],
    }),
    computed: {
        itemDiff: function() {
            if (!this.createForm) {
                return objDiff(this.originalItem, this.item)
            } else {
                return null
            }
        },
        invalidEmails() {
            const email = this.item?.email
            if (!email) return []
            const arr = Array.isArray(email) ? email : [email]
            return arr
                .map(e => (e || '').trim().toLowerCase())
                .filter(e => e && !this.isValidEmail(e))
        },
        contactEmailOptions() {
            const used = new Set(
                (this.emails || [])
                    .map(e => {
                        const mail =
                            typeof e === 'string' ? e : (e && e.email) || ''
                        return mail.trim().toLowerCase()
                    })
                    .filter(Boolean)
            )
            if (!this.createForm && this.item?.email) {
                const raw =
                    typeof this.item.email === 'string'
                        ? this.item.email
                        : this.item.email?.email || ''
                const current = raw.trim().toLowerCase()
                if (current) used.delete(current)
            }
            return this.usersEmailsList.filter(
                email => email && !used.has(email.trim().toLowerCase())
            )
        },
    },
    async mounted() {
        try {
            this.loading = true
            this.loadingContacts = true
            const {
                data: { users },
            } = await API.getLiteUsers()
            this.usersEmailsList = (users || [])
                .filter(u => u && u.email)
                .map(u => u.email.trim().toLowerCase())
        } catch (error) {
            this.setErrorItems({
                name: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
            this.loadingContacts = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async saveProcess() {
            if (this.createForm) {
                await this.create()
            } else {
                await this.update()
            }
        },
        onPasteEmails(e) {
            const text =
                (e.clipboardData || window.clipboardData)?.getData('text') || ''
            if (!text) return
            const parts = text
                .split(/[\s,;]+/)
                .map(s => s.trim())
                .filter(Boolean)
            const email = this.normalizeEmail(parts[0])
            if (email) {
                e.preventDefault()
                this.item.email = email
            }
        },
        isValidEmail(e) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
        },
        normalizeEmail(email) {
            const norm = (email || '').trim().toLowerCase()
            return norm || null
        },
        async create() {
            try {
                this.loading = true
                const item = await API.createEmailForClosureNotifications({
                    settingId: this.projectsSettings.id,
                    ...this.item,
                })
                this.$emit('addItem', item)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async update() {
            try {
                this.loading = true
                const item = await API.updateEmailForClosureNotifications({
                    settingId: this.projectsSettings.id,
                    id: this.item.id,
                    ...this.itemDiff,
                })
                this.$emit('replaceItem', item)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style></style>
